import { render, staticRenderFns } from "./SamplechecksDetail.vue?vue&type=template&id=5466fe5e&scoped=true&"
import script from "./SamplechecksDetail.vue?vue&type=script&lang=js&"
export * from "./SamplechecksDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5466fe5e",
  null
  
)

export default component.exports